module.exports = __webpack_public_path__ + "static/media/refund-successful-white-icon.e69402d5.svg";